var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'UIElement',
    _vm.$style.Tabs
  ]},_vm._l((_vm.tabs),function(tab){return _c('button',{key:tab.id,class:[
      _vm.$style.Tab,
      _vm.selected === tab.id && _vm.$style.Tab__selected
    ],attrs:{"type":"button"},on:{"click":function($event){return _vm.onChange(tab)},"mouseup":function($event){return $event.currentTarget.blur()}}},[_c('div',{class:_vm.$style.Tab_title},[_vm._v(" "+_vm._s(tab.label)+" "),(tab.badge)?_c('Badge',{class:_vm.$style.Tab_badge,attrs:{"size":"small"}},[_vm._v(_vm._s(tab.badge))]):_vm._e()],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }